document.addEventListener('alpine:init', () => {
  Alpine.data('banners', () => ({
    heading: '',
    text: '',
    showNewBanner: false,

    // Highest priority first: the first metric over its threshold is shown
    messages: [
      { metric: 'purchases', threshold: 15, heading: 'purchasedHeading', text: 'purchasedText' },
      { metric: 'addedToCart', threshold: 40, heading: 'addedToCartHeading', text: 'addedToCartText' },
      { metric: 'views', threshold: 100, heading: 'viewedHeading', text: 'viewedText' },
    ],

    init() {
      this.getNewBanner();
    },

    getNewBanner() {
      const data = this.$el.dataset;
      const message = this.messages.find((m) => Number(data[m.metric] || 0) > m.threshold);

      if (!message) return;

      const quantity = this.roundNumbertoNearestTen(Number(data[message.metric]));
      this.heading = data[message.heading];
      this.text = data[message.text].replace('[quantity]', quantity);
      this.showNewBanner = true;
    },

    roundNumbertoNearestTen(num) {
      return (Math.round(num / 10) * 10).toLocaleString('en-GB');
    },
  }));
});
